import { Alert, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, Input, Link, TextField } from "@mui/material";
import { Backend } from "../services/Backend";
import { useState } from "react";
import Cookies from "universal-cookie";
import { BreakfastDiningOutlined } from "@mui/icons-material";
import { MuiOtpInput } from "mui-one-time-password-input";
import { SuccessToast } from "../utils/utils";

const WindowState = {
    EnterEmail: 1,
    OTPVerification: 2,
    ResetPassword: 3,
}

export function ForgotPasswordPage() {
    const [windowState, setWindowState] = useState(WindowState.EnterEmail);

    let Component = <div></div>

    switch(windowState) {
        case WindowState.EnterEmail:
            Component = EnterEmailWindow;
            break;
        case WindowState.OTPVerification:
            Component = OTPVerification;
            break;
        case WindowState.ResetPassword:
            Component = ResetPassword;
            break;
        default:
            break;
    }
    
    return (
        <div className="w-[400px] mx-[auto] mt-[150px]">
            <Component setWindowState={setWindowState} />
        </div>
    );

}

function EnterEmailWindow({ setWindowState }) {
    const [error, setError] = useState("");
    const [email, setEmail] = useState("");

    const onSend = () => {

        Backend.put("auth/reset-password", email)
            .then(res => {
                setWindowState(WindowState.OTPVerification);
            })
            .catch(err => {
                setError(err);
            });
    }

    return <>
        <h1 className="text-4xl text-center mb-[50px]">Reset your password</h1>
        <p>Enter your email account to reset password</p>
        {error && <Alert severity="error">{error}</Alert> }
        <Box component="form" sx={{ mt: 1 }}>
            <TextField margin="normal" required fullWidth label="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} /> 
            <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={onSend}
            >
            Send
            </Button>
        </Box>
    </>
}



function OTPVerification({ setWindowState }) {
    const [error, setError] = useState("");
    const [otp, setOtp] = useState("");

    const onSend = () => {
        Backend.post("auth/otp-verification", otp)
            .then(res => {
                if (res) {
                    window.history.replaceState(null, null, `?otp=${otp}`);
                    setWindowState(WindowState.ResetPassword);
                } else {
                    setError("OTP is wrong");
                }
            })
            .catch(err => {
                setError(err);
            });
    }

    return <>
        <h1 className="text-4xl text-center mb-[50px]">OTP verification</h1>
        <p>Check your email to see the verification code</p>
        {error && <Alert severity="error">{error}</Alert> }
        <Box component="form" sx={{ mt: 1 }}>
            <MuiOtpInput label="Verification code" value={otp} onChange={(value) => setOtp(value)}  />
            <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={onSend}
            >
            Send
            </Button>
        </Box>
    </>
}

function ResetPassword({ setWindowState }) {
    const [error, setError] = useState("");
    const [newPassword, setEmail] = useState("");
    const urlParams = new URLSearchParams(window.location.search);
    const otp = urlParams.get('otp');

    const onSend = () => {
        const body =  { newPassword, otp };

        Backend.post("auth/update-password", body)
            .then(res => {
                SuccessToast("Password updated!");
                setTimeout(() => window.location.href = '/signin', 1000);
            })
            .catch(err => {
                setError(err);
            });
    }

    return <>
        <h1 className="text-4xl text-center mb-[50px]">Reset your password</h1>
        <p>Enter new password</p>
        {error && <Alert severity="error">{error}</Alert> }
        <Box component="form" sx={{ mt: 1 }}>
            <TextField margin="normal" type="password" required fullWidth label="Password" value={newPassword} onChange={(e) => setEmail(e.target.value)} /> 
            <Button
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            onClick={onSend}
            >
            Send
            </Button>
        </Box>
    </>
}